module.exports = __webpack_public_path__ + "static/media/Stellar Ora King Headboard - 180 cm_Cream.a79c40fd.png";